// cart-drawer-extension.js

// Wait for both DOM and custom elements to be ready
function initCartDrawerExtension() {
    // Get the original cart drawer class
    const originalDrawer = customElements.get('ap-cartdrawer');
    if (!originalDrawer) {
        // If not found, retry after a short delay
        setTimeout(initCartDrawerExtension, 100);
        return;
    }

    // Store the original setAttribute method
    const originalSetAttribute = originalDrawer.prototype.setAttribute;

    // Override setAttribute with new functionality
    originalDrawer.prototype.setAttribute = function(name, value) {
        // Check for wine club popup only when setting 'open' attribute
        if (name === 'open' && value !== null) {
            const wineClubPopup = document.getElementById('wine-club-popup');
            // If wine club popup is active, prevent cart from opening
            if (wineClubPopup?.classList.contains('active')) {
                return;
            }
        }
        // Call the original setAttribute with proper context
        originalSetAttribute.call(this, name, value);
    };
}

// Start the initialization
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerExtension);
} else {
    initCartDrawerExtension();
}
